import React, {forwardRef} from 'react'
import { useNavigate } from "react-router-dom"

const BurgerModal = forwardRef((props, ref) => {

    const navigate = useNavigate()
    return <div ref={ref} className={`burgerDiv ${props.burgerModalOpen ? 'in' : 'out'} ${props.load ? 'load' : ''}`}>
          <button
            onClick={() => {
                props.handleBurger()
                navigate(`/connection?log=${props.user.connected ? 'out' : 'in'}`)
            }}
          >
            {props.getLoginButtonText(props.lang, props.user.connected)}
          </button>

          {!props.user.connected && <button
            onClick={() => {
                props.handleBurger()
                navigate(`/connection?register=${props.user.connected ? 'out' : 'in'}`)
            }}
          >
            {props.getRegisterButtonText(props.lang, props.user.connected)}
          </button>}
    </div>
})

export default BurgerModal